import {
  Typography,
  useTheme,
  useMediaQuery,
  Paper,
  Button,
} from "@mui/material";
import AccordionSection from "../../shared/accordionSection";
import SimpleTable from "../../shared/simpleTable";
import { TableColumnAlign } from "@/app/models/common/tableColumnAlign";
import { useNavigate } from "react-router-dom";
import { RelatedOrderModel } from "@/app/interfaces/response/OrderDetailsResponse";
import CommonHelper from "@/app/helpers/CommonHelper";

const TITLE = "Related Orders";
const HEADERS = [
  "Order Date",
  "Order #",
  "Order Status",
  "Order Total",
  "Details",
];

const ALIGN: TableColumnAlign[] = [
  "center",
  "center",
  "center",
  "center",
  "center",
];

const RelatedOrders = ({
  relatedOrders,
}: {
  relatedOrders: RelatedOrderModel[];
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const rows = relatedOrders.map((order) => [
    order.createdOnUtc,
    order.customOrderNumber,
    order.inforStatus,
    CommonHelper.addDolarSign(order.total),
    <Button
      onClick={() => navigate(`/order/details/${order.id}`)}
      sx={{ fontSize: "0.875rem", fontWeight: 600 }}
    >
      DETAILS
    </Button>,
  ]);

  const content = (
    <Paper sx={{ mt: 1, p: isMobile ? 1 : 3 }}>
      {!isMobile && (
        <Typography
          variant="subtitle1"
          fontWeight={600}
          color="text.secondary"
          mb={2}
        >
          {TITLE}
        </Typography>
      )}

      <SimpleTable headers={HEADERS} rows={rows} align={ALIGN} />
    </Paper>
  );

  return isMobile ? (
    <AccordionSection title={TITLE}>{content}</AccordionSection>
  ) : (
    content
  );
};

export default RelatedOrders;
